import { Component } from '@angular/core';
import { ConfigService } from '@nx-ratenow/core/config';
import { UserFacade } from '@nx-ratenow/core/data-access-user';
import { environment } from '@nx-ratenow/core/environment';
import { AplicationTypeName } from '@nx-ratenow/shared/enums';
import { PopoverRef } from '@nx-ratenow/shared/feature-popover';

export interface AppsMenu {
  icon: string;
  label: string;
  route: string;
  appType: string;
  disabled: boolean;
  authority: string;
}

@Component({
  standalone: false,
  selector: 'nx-ratenow-apps-menu',
  templateUrl: './apps-menu.component.html',
  styleUrl: './apps-menu.component.scss'
})
export class AppsMenuComponent {
  apps: AppsMenu[] = [
    {
      icon: 'mat:analytics',
      label: 'ANALYTICS',
      route: `https://reports${environment.name}.ratenow.es/`,
      appType: AplicationTypeName.analytics,
      disabled: false,
      authority: 'RNA_LOGIN'
    },
    {
      icon: 'mat:admin_panel_settings',
      label: 'ADMIN',
      route: `https://admin${environment.name}.ratenow.es/`,
      appType: AplicationTypeName.adminWeb,
      disabled: false,
      authority: 'ADMIN_LOGIN'
    },
    {
      icon: 'mat:loop',
      label: 'CTL',
      route: `https://ctl${environment.name}.ratenow.es/`,
      appType: AplicationTypeName.closeTheLoop,
      disabled: false,
      authority: 'CTL_LOGIN'
    },
    {
      icon: 'mat:settings',
      label: 'CONFIG',
      route: `https://config${environment.name}.ratenow.es/`,
      appType: AplicationTypeName.adminUsers,
      disabled: false,
      authority: 'CFG_LOGIN'
    },
    {
      icon: 'mat:file_download',
      label: 'IMPORTS',
      route: `https://import${environment.name}.ratenow.es/`,
      appType: AplicationTypeName.imports,
      disabled: false,
      authority: 'IMP_LOGIN'
    },
    {
      icon: 'mat:rate_review',
      label: 'EDIT SURVEY',
      route: `${environment.autoEditor}`,
      appType: AplicationTypeName.editSurvey,
      disabled: false,
      authority: 'SED_LOGIN'
    }
  ];

  constructor(
    private popoverRef: PopoverRef<AppsMenuComponent>,
    private configService: ConfigService,
    private userFacade: UserFacade
  ) {
    this.userFacade.userLogged$.subscribe((user) => {
      this.apps = this.apps.filter((app) => app.appType != this.configService.aplicationName);

      this.apps = this.apps.filter((app) => user.authorities.includes(app.authority));

      if (this.popoverRef.data) {
        this.apps = this.apps.filter((x) => (<any>this.popoverRef.data).applications.includes(x.appType));
      }
    });
  }

  close(app: AppsMenu) {
    window.open(app.route, '_blank');
    this.popoverRef.close();
  }
}
